import { InterpolationOptions } from 'i18next';
import { currencyToSymbol } from 'shared/components/MoneyView';
import { Money } from 'shared/types/common';

export const i18nextInterpolation: Partial<InterpolationOptions> = {
  format(value: any, format?: string, lng?: string) {
    if (format === 'money') {
      if (!('value' in value) || typeof value.value !== 'number' || !('currency' in value)) {
        console.error(`[i18next]: money formatter accepts Money interface`);
        return value;
      }
      const amount = value as Money;
      return `${amount.value.toLocaleString(lng, { maximumFractionDigits: 2 })} ${currencyToSymbol(
        amount.currency
      )}`;
    }
    return value;
  },
};
